<app-navbar></app-navbar>

<div class="payment-failure-container">
  <div class="result-card">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <div class="spinner"></div>
        <h2>Verificando el estado de tu pago...</h2>
        <p>Por favor espera mientras confirmamos tu transacción.</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <div class="error-state">
        <div class="icon-container error">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h2>Problema con la verificación</h2>
        <p class="error-message">{{ error }}</p>
        
        <div class="action-buttons">
          <button class="btn btn-primary" (click)="retryPayment()">
            <i class="fas fa-redo"></i>
            Intentar Nuevamente
          </button>
          <button class="btn btn-secondary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>
      </div>
    }

    <!-- Failure State -->
    @if (paymentDetails && !error && !isLoading) {
      <div class="failure-state">
        <div class="icon-container failure">
          <i class="fas fa-times-circle"></i>
        </div>
        
        <h2>Pago No Procesado</h2>
        <p class="failure-message">Tu pago no pudo ser procesado exitosamente.</p>

        <div class="payment-details">
          <h3>Detalles del Intento de Pago</h3>
          <div class="detail-row">
            <span class="label">ID de Reserva:</span>
            <span class="value">{{ reservation_id }}</span>
          </div>
          @if (payment_id) {
            <div class="detail-row">
              <span class="label">ID de Pago:</span>
              <span class="value">{{ payment_id }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status) {
            <div class="detail-row">
              <span class="label">Estado:</span>
              <span class="value status failed">{{ paymentDetails.payment.status }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status_description) {
            <div class="detail-row">
              <span class="label">Motivo:</span>
              <span class="value">{{ paymentDetails.payment.status_description }}</span>
            </div>
          }
        </div>

        <div class="reasons-container">
          <h3>Posibles Motivos</h3>
          <ul class="reasons-list">
            <li><i class="fas fa-credit-card"></i> Fondos insuficientes en tu tarjeta</li>
            <li><i class="fas fa-ban"></i> La tarjeta fue rechazada por el banco</li>
            <li><i class="fas fa-exclamation-circle"></i> Datos de la tarjeta incorrectos</li>
            <li><i class="fas fa-clock"></i> Límite de tiempo excedido</li>
            <li><i class="fas fa-shield-alt"></i> Bloqueo por seguridad del banco</li>
          </ul>
        </div>

        <div class="next-steps">
          <h3>¿Qué Puedes Hacer?</h3>
          <ul>
            <li><i class="fas fa-redo"></i> Intentar el pago nuevamente</li>
            <li><i class="fas fa-credit-card"></i> Usar otra tarjeta o método de pago</li>
            <li><i class="fas fa-phone"></i> Contactar a tu banco para verificar el estado de tu tarjeta</li>
            <li><i class="fas fa-headset"></i> Contactar nuestro soporte si el problema persiste</li>
          </ul>
        </div>

        <div class="action-buttons">
          <button class="btn btn-primary" (click)="retryPayment()">
            <i class="fas fa-redo"></i>
            Intentar Nuevamente
          </button>
          <button class="btn btn-secondary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>

        @if (paymentDetails.can_retry) {
          <div class="retry-notice">
            <i class="fas fa-info-circle"></i>
            <p>Tu reserva sigue disponible. Puedes intentar el pago nuevamente desde tu dashboard.</p>
          </div>
        }
      </div>
    }
  </div>
</div>

<app-footer></app-footer>
